import React from 'react';
import CoinyLogoMonocolor from 'util/svg/logo/ShapesOfCoinSvg';
import LogoText from "./logo/LogoText";

const svgElements = {
    'images': (size, color) => (
        <svg
            width={size}
            height={size}
            viewBox="1 1 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx={12} cy={9} r={3} fill={color}/>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.4514 15.9084C17.5088 16.0121 17.4793 16.1415 17.3843 16.2125C15.8828 17.3352 14.0191 18 12.0001 18C9.98102 18 8.11725 17.3351 6.61576 16.2124C6.52078 16.1414 6.49125 16.0121 6.54868 15.9083C7.49884 14.1915 9.58245 13 12 13C14.4176 13 16.5012 14.1915 17.4514 15.9084Z"
                fill={color}
            />
            <path
                d="M17 4H17.502C18.7134 4 19.319 4 19.7834 4.232C20.2095 4.44495 20.5551 4.79048 20.768 5.21665C21 5.68096 21 6.28664 21 7.498V8M17 20H17.502C18.7134 20 19.319 20 19.7834 19.768C20.2095 19.5551 20.5551 19.2095 20.768 18.7834C21 18.319 21 17.7134 21 16.502V16M7 4H6.498C5.28664 4 4.68096 4 4.21665 4.232C3.79048 4.44495 3.44495 4.79048 3.232 5.21665C3 5.68096 3 6.28664 3 7.498V8M7 20H6.498C5.28664 20 4.68096 20 4.21665 19.768C3.79048 19.5551 3.44495 19.2095 3.232 18.7834C3 18.319 3 17.7134 3 16.502V16"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    ),
    'lootbox': (size, color) => (
        <svg
            width={size}
            height={size}
            viewBox="-1 -1 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5 4.5H19C19.7956 4.5 20.5587 4.81607 21.1213 5.37868C21.6839 5.94129 22 6.70435 22 7.5V11.5H15V10.5H9V11.5H2V7.5C2 6.70435 2.31607 5.94129 2.87868 5.37868C3.44129 4.81607 4.20435 4.5 5 4.5ZM11 11.5H13V13.5H11V11.5ZM2 12.5H9V13.5L11 15.5H13L15 13.5V12.5H22V20.5H2V12.5Z"
                fill={color}
            />
        </svg>
    ),
    'store': (size, color) => (
        <svg
            width={size}
            height={size}
            style={{transform: "scaleX(-1)"}}
            viewBox="2 2 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4 4H5.62563C6.193 4 6.47669 4 6.70214 4.12433C6.79511 4.17561 6.87933 4.24136 6.95162 4.31912C7.12692 4.50769 7.19573 4.7829 7.33333 5.33333L7.51493 6.05972C7.616 6.46402 7.66654 6.66617 7.74455 6.83576C8.01534 7.42449 8.5546 7.84553 9.19144 7.96546C9.37488 8 9.58326 8 10 8V8"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M18 17H7.55091C7.40471 17 7.33162 17 7.27616 16.9938C6.68857 16.928 6.28605 16.3695 6.40945 15.7913C6.42109 15.7367 6.44421 15.6674 6.49044 15.5287V15.5287C6.54177 15.3747 6.56743 15.2977 6.59579 15.2298C6.88607 14.5342 7.54277 14.0608 8.29448 14.0054C8.3679 14 8.44906 14 8.61137 14H14"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.7639 14H9.69425C8.71658 14 7.8822 13.2932 7.72147 12.3288L7.2911 9.7466C7.13872 8.8323 7.84378 8 8.77069 8H18.382C19.1253 8 19.6088 8.78231 19.2764 9.44721L17.5528 12.8944C17.214 13.572 16.5215 14 15.7639 14Z"
                fill={color}
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
            <circle cx={17} cy={20} r={1} fill={color}/>
            <circle cx={9} cy={20} r={1} fill={color}/>
        </svg>
    ),
    'my-items': (size, color) => (
        <svg
            width={size}
            height={size}
            viewBox="-1.5 -1.5 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.0777 17.1149C23.0777 22.2097 18.4629 24.5 12 24.5C5.53716 24.5 0.920593 22.2097 0.920593 17.1509C0.920593 12.308 3.03774 9.55315 7.27202 7.06229C8.63663 8.08769 10.2977 8.64154 12.0046 8.6403C13.7115 8.63906 15.3718 8.08281 16.7349 7.05543C20.964 9.52057 23.0777 12.2754 23.0777 17.1149ZM14.988 5.65657L17.1652 2.25372C17.2592 2.07312 17.3057 1.87156 17.3003 1.66802C17.295 1.46449 17.2379 1.26566 17.1345 1.09026C17.0311 0.914855 16.8848 0.768643 16.7093 0.665383C16.5339 0.562122 16.335 0.50521 16.1315 0.500002H8.30231C8.08516 0.495883 7.87096 0.550777 7.68255 0.658829C7.49415 0.766882 7.3386 0.924042 7.23249 1.11355C7.12639 1.30306 7.07371 1.51781 7.08007 1.73491C7.08642 1.95201 7.15158 2.16331 7.26859 2.34629L9.06345 5.68915C10.8823 6.77772 13.1777 6.76743 14.988 5.65657Z"
                fill={color}
            />
        </svg>
    ),
    'chat': (size, color) => (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3a9 9 0 0 0 0 18h4.5c1.398 0 2.097 0 2.648-.228a3 3 0 0 0 1.624-1.624C21 18.597 21 17.898 21 16.5V12a9 9 0 0 0-9-9m-4 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m3 4a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1"
                fill={color}
            />
        </svg>
    ),
    'wall': (size, color) => (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.4 3.6v4.8H3.6V7.2a3.6 3.6 0 0 1 3.6-3.6zm1.2 0v10.8h7.8V7.2a3.6 3.6 0 0 0-3.6-3.6zm7.8 12h-7.8v4.8h4.2a3.6 3.6 0 0 0 3.6-3.6zm-9 4.8V9.6H3.6v7.2a3.6 3.6 0 0 0 3.6 3.6z"
                fill={color}
            />
        </svg>
    ),
    'bell': (size, color) => (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.502 6.975a5.525 5.525 0 0 1 10.996 0l.286 2.866c.018.175.026.262.037.348a8 8 0 0 0 1.19 3.325l.192.291.861 1.292c.787 1.18 1.18 1.769 1.008 2.244q-.05.136-.135.252c-.3.407-1.009.407-2.426.407H5.489c-1.417 0-2.126 0-2.426-.407a1 1 0 0 1-.134-.252c-.173-.475.22-1.065 1.006-2.244l.862-1.292.192-.291a8 8 0 0 0 1.19-3.325c.01-.086.02-.173.037-.348z"
                fill={color}
            />
            <path
                d="M10.068 20.63c.114.106.365.2.715.267.349.067.777.103 1.217.103s.868-.036 1.217-.103.6-.161.715-.268"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    ),
    'plus': (size, color) => (
        <svg
            width={size}
            height={size}
            viewBox="1 1 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 6v12m6-6H6"
                stroke={color}
                strokeWidth={2.7}
                strokeLinecap="round"
            />
        </svg>
    ),
    'menu': (size, color) => (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5 7h14M5 12h14M5 17h14"
                stroke="#33363F"
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    ),
    'set-profile': (size, color) => (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10a9.98 9.98 0 0 1-3.443 7.55 7 7 0 0 0-13.114 0A9.98 9.98 0 0 1 2 12m14.83 8.706.013.045A9.96 9.96 0 0 1 12 22a9.96 9.96 0 0 1-4.843-1.249q.008-.022.013-.045a5 5 0 0 1 9.66 0M10 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
                fill={color}
            />
            <rect x={2.5} y={2.5} width={19} height={19} rx={9.5} stroke={color}/>
        </svg>
    ),
    'flex-hand': (size, color) => (
        <svg
            width={size}
            height={size}
            viewBox="270 100 170 170"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g mask="url(#mask0_395_99)">
                <path
                    d="M424.003 198.449c-7.455-13.228-31.367-26.804-57.438-16.575-20.232 7.934-24.622 22.589-26.405 25.47-2.453 3.934-7.567 3.053-7.567 3.053 2.69-8.254 3.108-18.295 2.146-25.483-.919-7.681-.905-14.202.14-20.429.613-3.641 1.63-7.268 3.386-10.562.501-.947 4.807-7.108 6.284-6.494 5.295 2.173 9.935 3.134 17.237 2.173 4.097-.533 11.858-2.04 13.279-2.92 1.756-1.093 2.035-1.8 2.035-1.8.641-4.494-1.644-7.414-1.644-7.414s7.092-1.334 9.196-6.868c.627-1.654-1.951-5.574-2.884-7.188-3.135-5.441-7.762-12.934-12.137-16.509-2.146-1.76-9.253-5.72-18.644-.453-13.656 7.668-32.022 16.149-54.985 69.116-6.94 16.002-10.521 47.9-10.744 56.995-.265 10.694 1.895 21.576 30.837 26.856 21.682 3.961 37.456 4.414 62.928 4.414 7.901 0 35.17-2.04 45.147-20.096 9.183-16.615 5.908-34.498-.167-45.286"
                    fill={color}
                />
                <path
                    d="M377.089 144.874c.501-3.547-.795-6.081-1.38-7l-6.911 2.133s-.223 1.787 0 4.494c.209 2.707-7.023 5.108-7.023 5.108 4.096-.534 11.858-2.041 13.279-2.921 1.756-1.093 2.035-1.814 2.035-1.814m-42.347 40.032c-.92-7.68-.906-14.201.139-20.429.613-3.64 1.63-7.267 3.386-10.561.502-.934 4.71-6.974 6.229-6.508l-1.77-2.147s-6.661 3.748-10.98 10.868c-4.306 7.134-2.745 20.07-3.72 32.271-.976 12.189-10.591 25.91-10.591 25.91l15.147-3.92c.014 0 3.985-11.788 2.16-25.484m-18.63 74.517c21.681 3.961 37.455 4.414 62.927 4.414 7.901 0 35.17-2.04 45.148-20.096 9.182-16.616 4.932-36.632.961-43.139-.613-1-4.947-10.762-10.632-4.467-2.382 2.627 1.198 7.361.098 15.575-4.71 35.458-41.427 31.458-41.427 31.458-17.641 13.508-59.793 8.841-68.641 8.374-1.017-.053-3.498-.694-4.222 1.253s1.783 2.975 3.205 3.468c3.497 1.187 7.65 2.253 12.583 3.16"
                    fill={color}
                />
                <path
                    d="M378.953 128.345c-.418-1.053-7.051-2.573-8.862-3.413-1.895-.934-3.386-2.681-4.223-4.228l.07-.173c.014-.054 1.965-5.374.335-6.054-.892-.374-1.561.706-1.728 1.16-2.286 5.974-8.027 8.521-9.671 15.189l-2.856-2.081c-.808-.586-1.282-.387-1.547-.12-1.045 1.094 2.09 4.401 2.132 4.427 4.069 4.228 8.277 8.588 12.889 9.028 2.132.214 6.94-1.16 8.556-1.653.293 1.147.376 4.24.293 6.574 4.932-1.52 4.779-6.094 3.762-10.375 0 0-9.559 3.201-12.499 1.627-2.773-1.266-5.379-2.467-6.479-4.28-.614-1.014 1.295-5.014 3.511-8.361 2.884 1.426 3.344 2.68 3.163 6.72-.126 1.001-.418 2.521.362 2.534 1.157.133 1.825-1.72 2.021-2.76.111-.534.724-2.027 1.226-2.467 1.184-1.041 2.369-.707 2.926-.601 4.208.708 7.218.961 6.619-.693m-64.544 95.6c-1.059 1.44-3.4.333-2.857-1.361.265-.813.6-1.706 1.018-2.68 2.006-4.734 5.476-10.188 10.743-11.775 8.918-2.68 9.28 2.254 9.28 2.254-8.556 3.454-14.366 8.361-18.184 13.562m26.224-73.357c-2.717-1.507-4.264-6.254-4.264-9.241s1.896-4.067 2.759-1.467c.864 2.6 2.899 5.361 6.898 7.948zm19.188 87.239c.864-1.334 2.913-.654 3.86-.28 5.448 2.16 16.833 7.147 30.976.52 18.365-8.602 19.243-24.137 19.243-24.137.209-2.04.753-2.787 2.341-2.894 1.826-.12 2.606 1.561 2.69 3.014.306 5.987.125 22.937-20.345 31.151-19.02 7.641-32.676-.467-36.94-3.667-1.003-.761-2.675-2.387-1.825-3.707"
                    fill={color}
                />
            </g>
        </svg>
    ),
    'hearth': (size, color) => (
        <svg
            width={size}
            height={size}
            viewBox="0 -20 520 500"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fill={color}
                  d="M253.647 83.481c130.392-219.054 509.908 65.493-.512 372.598-514.787-328.94-101.874-598.694.512-372.598z"/>
            <path fill={color}
                  d="M344.488 10.579c146.33-39.079 316.839 185.127-65.021 429.133C561.646 215.547 470.393 36.15 344.488 10.579zM121.413.645C170.08-4.2 221.438 18.567 250.749 77.574a201.544 201.544 0 013.537 11.587c10.541 34.29.093 49.643-12.872 50.552-18.137 1.271-20.216-14.851-24.967-27.643C192.689 48.096 158.774 12.621 116.43 1.862c1.653-.434 3.315-.84 4.983-1.217z"/>
            <path fill={color}
                  d="M130.558 35.501c-42.657-4.246-87.652 23.898-99.173 66.067-7.868 25.593-.07 37.052 9.607 37.73 13.537.949 15.088-11.084 18.635-20.632 17.732-47.748 43.045-74.226 74.65-82.256a107.173 107.173 0 00-3.719-.909z"/>
        </svg>
    ),
    'book': (size, color) => (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20 12v5c0 1.886 0 2.828-.586 3.414S17.886 21 16 21H6.5a2.5 2.5 0 0 1 0-5H16c1.886 0 2.828 0 3.414-.586S20 13.886 20 12V7c0-1.886 0-2.828-.586-3.414S17.886 3 16 3H8c-1.886 0-2.828 0-3.414.586S4 5.114 4 7v11.5"
                stroke={color}
                strokeWidth={2}
            />
            <path d="M9 8h6" stroke={color} strokeWidth={2} strokeLinecap="round"/>
        </svg>
    ),
    'logo': (size, color) => (
        <CoinyLogoMonocolor size={(size * 659) / 470} color={color}/>
    ),
    'logo-flexagren': (size, color) => (
        <svg
            width={size * 4}
            height={size}
            viewBox="0 0 96 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <CoinyLogoMonocolor size={(size * 659) / (470 * 2)} color={color}/>
            <g transform="translate(34, 5)">
                <LogoText width={size * 1.2} outerCircleC={color} isCashTenant={false}/>
            </g>
        </svg>
    ),
    'logo-flextagram': (size, color) => (
        <svg
            width={size * 5}
            height={size}
            viewBox="0 0 120 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <CoinyLogoMonocolor size={(size * 659) / (470 * 2)} color={color}/>
            <g transform="translate(34, 5)">
                <LogoText width={size * 1.38} outerCircleC={color} isCashTenant={true}/>
            </g>
        </svg>
    ),
    'login': (size, color) => (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.929 19.071a10 10 0 1 0 0-14.142"
                stroke={color}
                strokeWidth={2}
            />
            <path
                d="m15 12 .78-.625.5.625-.5.625zM3 13a1 1 0 1 1 0-2zm8.78-6.625 4 5-1.56 1.25-4-5zm4 6.25-4 5-1.56-1.25 4-5zM15 13H3v-2h12z"
                fill={color}
            />
        </svg>
    ),
    'credit-card': (size, color) => (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x={3}
                y={6}
                width={18}
                height={13}
                rx={2}
                stroke={color}
                strokeWidth={2}
            />
            <path
                d="M7 15h.01M4 11h17"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    ),
    'share': (size, color) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
        >
            <path
                d="M 18 2 A 3 3 0 0 0 15 5 A 3 3 0 0 0 15.054688 5.5605469 L 7.9394531 9.7109375 A 3 3 0 0 0 6 9 A 3 3 0 0 0 3 12 A 3 3 0 0 0 6 15 A 3 3 0 0 0 7.9355469 14.287109 L 15.054688 18.439453 A 3 3 0 0 0 15 19 A 3 3 0 0 0 18 22 A 3 3 0 0 0 21 19 A 3 3 0 0 0 18 16 A 3 3 0 0 0 16.0625 16.712891 L 8.9453125 12.560547 A 3 3 0 0 0 9 12 A 3 3 0 0 0 8.9453125 11.439453 L 16.060547 7.2890625 A 3 3 0 0 0 18 8 A 3 3 0 0 0 21 5 A 3 3 0 0 0 18 2 z"
                fill={color}
            />
        </svg>
    ),
    'donations': (size, color) => (
        <svg
            width={size}
            height={size}
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="m14.7 11.018 4.54-2.62a.796.796 0 0 1 1.086.29l.097.168a3.63 3.63 0 0 1 .061 3.518 2.903 2.903 0 0 1-3.742 1.29l-1.948-.866a1 1 0 0 1-.093-1.78Zm0 1.964 4.54 2.62c.38.22.51.706.29 1.087l-.096.167a3.63 3.63 0 0 1-3.015 1.812 2.903 2.903 0 0 1-2.989-2.596l-.224-2.12a1 1 0 0 1 1.495-.97Zm-1.7.982v5.24c0 .44-.356.796-.796.796h-.193a3.63 3.63 0 0 1-3.077-1.705 2.903 2.903 0 0 1 .754-3.887l1.724-1.253a1 1 0 0 1 1.588.809Zm-1.7-.982-4.54 2.62a.796.796 0 0 1-1.086-.29l-.097-.168a3.63 3.63 0 0 1-.061-3.518 2.903 2.903 0 0 1 3.742-1.29l1.948.866a1 1 0 0 1 .093 1.78Zm0-1.964-4.54-2.62a.795.795 0 0 1-.29-1.087l.096-.168a3.63 3.63 0 0 1 3.015-1.812 2.903 2.903 0 0 1 2.989 2.597l.223 2.119a1 1 0 0 1-1.494.971Zm1.7-.982v-5.24c0-.44.356-.796.796-.796h.193c1.251 0 2.414.644 3.077 1.705a2.903 2.903 0 0 1-.754 3.887l-1.724 1.253A1 1 0 0 1 13 10.036Z"
                stroke={color}
                strokeWidth={2}
            />
        </svg>
    ),
    'fire': (size, color) => (
        <svg
            width={size}
            height={size}
            viewBox="1.5 2 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.367 4.061C9.667 4.567 5 8.158 5 14a7 7 0 0 0 6.92 7 4 4 0 0 1-3.874-4.616c.336-2.254 2.41-4.167 3.412-4.974a.856.856 0 0 1 1.084 0c1.003.807 3.076 2.72 3.412 4.974l.004.034Q16 16.703 16 17a4 4 0 0 1-3.92 4A7 7 0 0 0 19 14.057V14c-.026-4.241-2.896-6.555-3.419-6.942a.14.14 0 0 0-.163 0c-.21.155-.794.618-1.421 1.39a.156.156 0 0 1-.26-.032c-1.18-2.495-2.813-4.009-3.198-4.345a.135.135 0 0 0-.172-.01"
                fill={color}
            />
        </svg>
    )
};

const NavigationMenuSvg = ({name, size = 24, color = 'black', isMoneyTenant}) => {
    return svgElements[name]?.(size, color, isMoneyTenant) || null;
};

export default NavigationMenuSvg;